export const mailto = 'team@qura.law';

export const getQuickGuideUrl = (lang: string) => {
  if (lang === 'sv') lang = '';
  return `https://www.qura.law/quick-guide${lang && `-${lang}`}`;
};
